import clsx from 'clsx';
import Image from 'next/image';
import downArrow2Png from '../../assets/images/rewards-program/down-arrow2.png';
import pointsPng from '../../assets/images/rewards-program/points.png';
import redeemPointsPng from '../../assets/images/rewards-program/redeem-points.png';
import signUpPng from '../../assets/images/rewards-program/sign-up.png';

const WorkSteps = props => {
  return (
    <div className={clsx('lg_pb-[113px] lg_pt-[60px]', 'lg_bg-[#F6F6F6] ', 'font-poppins', props.className)}>
      <h2 className='text-center font-poppins text-lg font-[600] leading-[22px] text-primary lg_text-[30px] lg_leading-10'>
        HOW IT WORKS
      </h2>

      {/* pc */}
      <div className='mx-auto mt-[50px] hidden max-w-[1440px] items-center justify-between gap-x-4 px-[110px] lg_flex'>
        <div className='flex shrink-0 grow-0 basis-[160px] flex-col items-center'>
          <Image
            src={signUpPng}
            alt='sign-up'
            width={60}
            height={60}
          />
          <p className=' mt-5 text-[20px] font-normal leading-[22px] text-primary'>SIGN UP</p>
        </div>
        <div className='h-[3px] w-[300px] shrink grow-0 bg-primary' />
        <div className='flex shrink-0 grow-0  basis-[160px] flex-col items-center'>
          <Image
            src={pointsPng}
            alt='earn-points'
            width={60}
            height={60}
          />
          <p className=' mt-5 text-[20px] font-normal leading-[22px] text-primary'>EARN POINTS</p>
        </div>
        <div className='h-[3px] w-[300px] shrink grow-0 bg-primary' />
        <div className='flex shrink-0 grow-0  basis-[160px] flex-col items-center'>
          <Image
            src={redeemPointsPng}
            alt='redeem-points'
            width={60}
            height={60}
          />
          <p className=' mt-5 text-[20px] font-normal leading-[22px] text-primary'>REDEEM POINTS</p>
        </div>
      </div>
      <div
        className={clsx(
          'mx-auto mt-[5px] hidden max-w-[1440px] justify-between lg_flex',
          'text-center font-sans text-base  font-bold leading-5 text-title ',
        )}
      >
        <div className='basis-[380px] '>Create An Account And Get 100 Points.</div>
        <div className='basis-[422px] '>
          <div>Earn Points By Engaging In Interactions,</div>
          <div>Following Us, And Contributing In Our Facebook Group.</div>
          <div>($1 = 1 Point)</div>
        </div>
        <div className='basis-[380px] '>
          <div>Redeem Points For Deducting The Order Price </div>
          <div>And Coupons.</div>
          <div>(50 Points = $1)</div>
        </div>
      </div>

      {/* mobile */}
      <div className='mt-5 lg_hidden'>
        <div className='mx-3 flex items-center rounded-[10px] bg-[#EFEFEF] py-[35px] pl-5 pr-2.5'>
          <Image
            src={signUpPng}
            alt='sign-up'
            width={50}
            height={50}
            className='shrink-0 grow-0'
          />
          <div className='ml-[31px]'>
            <p className='text-sm leading-4 text-primary'>SIGN UP</p>
            <p className='mt-[3px] font-sans text-[13px] leading-4 text-[#8C8C8C]'>
              Create An Account And Get 100 Points.
            </p>
          </div>
        </div>

        <Image
          alt='down-arrow'
          width={15}
          height={16}
          src={downArrow2Png}
          className='mx-auto my-3'
        />

        <div className='mx-3 flex items-center rounded-[10px] bg-[#EFEFEF] py-[35px] pl-5 pr-2.5 '>
          <Image
            src={pointsPng}
            alt='sign-up'
            width={50}
            height={50}
            className='shrink-0 grow-0'
          />
          <div className='ml-[31px]'>
            <p className='text-sm leading-4 text-primary'>EARN POINTS</p>
            <p className='mt-[3px] font-sans text-[13px] leading-4 text-[#8C8C8C]'>
              Earn Points By Engaging In Interactions, Following Us, And Contributing In Our Facebook Group. ($1 = 1
              Point)
            </p>
          </div>
        </div>

        <Image
          alt='down-arrow'
          width={15}
          height={16}
          src={downArrow2Png}
          className='mx-auto my-3'
        />

        <div className='mx-3 flex items-center rounded-[10px] bg-[#EFEFEF] py-[35px] pl-5 pr-2.5 '>
          <Image
            src={redeemPointsPng}
            alt='sign-up'
            width={50}
            height={50}
            className='shrink-0 grow-0'
          />
          <div className='ml-[31px]'>
            <p className='text-sm leading-4 text-primary'>REDEEM POINTS</p>
            <p className='mt-[3px] font-sans text-[13px] leading-4 text-[#8C8C8C]'>
              Redeem Points For Deducting The Order Price And coupons. (50 Points = $1)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkSteps;
